import { useState, useRef, createContext } from "react"
import en from "../langs/en.json"

export const GlobalContext = createContext([{}, () => { }])

export const GlobalProvider = (props) => {
    // general variables
    const socketRef = useRef();
    const localSocketRef = useRef();
    const keyboardRef = useRef();
    // const notesRefs = useRef();

    const [socketToken, setSocketToken] = useState()
    const [ioSettings, setIoSettings] = useState();
    const [topics, setTopics] = useState([]);
    const [addGuest, setAddGuest] = useState();
    const [notesTexts, setNotesTexts] = useState([]);
    const selectedTopicIdRef = useRef();
    const [language, setLanguage] = useState(en)
    // const [conferenceStarted, setConferenceStarted] = useState(true);
    const [usingInvitation, setUsingInvitation] = useState(false);
    const [currentProject, setCurrentProject] = useState()
    const [projectsList, setProjectsList] = useState()
    const [selectedProject, setSelectedProject] = useState()

    const [allUsers, setAllUsers] = useState()
    const [upcomingConferences, setUpcomingConferences] = useState([])
    const [notificationUpcomingConferences, setNotificationUpcomingConferences] = useState([])
    const [historyConferences, setHistoryConferences] = useState([])
    const [statusProjectList, setStatusProjectList] = useState(true) // active = true, inactive = false, all = null
    const [detailsUpcomingConference, setDetailsUpcomingConference] = useState()
    const [invitationData, setInvitationData] = useState()
    const [conferenceLogin, setConferenceLogin] = useState()
    const [topicFiles, setTopicFiles] = useState()
    const [selectedParentForFiles, setSelectedParentForFiles] = useState()
    const [selectedRefTypeForFiles, setSelectedRefTypeForFiles] = useState()

    const [selectedTopic, setSelectedTopic] = useState()
    const [createNewProject, setCreateNewProject] = useState(false)

    const [departmentList, setDepartmentList] = useState()
    const [functionList, setFunctionList] = useState()

    // login variables
    const [currentUser, setCurrentUser] = useState()

    const [deviceId, setDeviceId] = useState();
    const [deskData, setDeskData] = useState()
    const [roomDataForRegister, setRoomDataForRegister] = useState()

    const [appHeight, setAppHeight] = useState()
    const [appWidth, setAppWidth] = useState()

    //Conference variables
    const [currentConference, setCurrentConference] = useState()
    const [currentParticipant, setCurrentParticipant] = useState()
    const [currentTopic, setCurrentTopic] = useState()
    const [currentModeratorStream, setCurrentModeratorStream] = useState()
    const [currentParticipantStream, setCurrentParticipantStream] = useState()
    const [alertMessage, setAlertMessage] = useState()

    const [openedFiles, setOpenedFiles] = useState([])
    const [sharedFiles, setSharedFiles] = useState([])

    const [openNotif, setOpenNotif] = useState(false)
    const [seeNotification, setSeeNotification] = useState(false)
    const [userDetailsComponentTimer, setUserDetailsComponentTimer] = useState(false)

    const [conferencePaused, setConferencePaused] = useState(false)

    const [videoStreams, setVideoStreams] = useState([]);
    const [audioStreams, setAudioStreams] = useState([]);
    const [hasUnreadMessages, setHasUnreadMessages] = useState(0);

    const [waitingForJoining, setWaitingForJoining] = useState(true);

    const [showSettings, setShowSettings] = useState(false);
    const [showControls, setShowControls] = useState(false);
    const [seeQrCode, setSeeQrCode] = useState(false)
    // const [videoPaused, setVideoStreams] = useState([]);

    const [openEditProfile, setOpenEditProfile] = useState(false)

    const [participantsStreams, setParticipantsStreams] = useState([]);
    const [refreshNotes, setRefreshNotes] = useState(false);

    // const localVolume = window.chrome?.webview?.hostObjects.volume;
    // const localSerial = window.chrome?.webview?.hostObjects.serial;
    // const localSystem = window.chrome?.webview?.hostObjects.systemInfo;

    const [iamRoomAdministrator, setIamRoomAdministrator] = useState(false)
    const [iamSubAdministrator, setIamSubAdministrator] = useState(false)

    const [loadingFiles, setLoadingFiles] = useState([])
    const [extraScreenOpenConf, setExtraScreenOpenConf] = useState(false)

    return (
        <GlobalContext.Provider value={{
            socketRef, keyboardRef, localSocketRef,
            //localVolume, localSystem, localSerial,
            // notesRefs,
            socketToken, setSocketToken,
            iamSubAdministrator, setIamSubAdministrator,
            topics, setTopics,
            iamRoomAdministrator, setIamRoomAdministrator,
            // conferenceStarted, setConferenceStarted,
            conferencePaused, setConferencePaused,
            waitingForJoining, setWaitingForJoining,
            addGuest, setAddGuest,
            selectedTopicIdRef,
            videoStreams, setVideoStreams,
            audioStreams, setAudioStreams,
            appHeight, setAppHeight,
            appWidth, setAppWidth,
            ioSettings, setIoSettings,
            notesTexts, setNotesTexts,
            language, setLanguage,
            currentUser, setCurrentUser,
            usingInvitation, setUsingInvitation,
            currentProject, setCurrentProject,
            projectsList, setProjectsList,
            selectedProject, setSelectedProject,
            allUsers, setAllUsers,
            upcomingConferences, setUpcomingConferences,
            notificationUpcomingConferences, setNotificationUpcomingConferences,
            historyConferences, setHistoryConferences,
            statusProjectList, setStatusProjectList,
            detailsUpcomingConference, setDetailsUpcomingConference,
            invitationData, setInvitationData,
            topicFiles, setTopicFiles,
            selectedParentForFiles, setSelectedParentForFiles,
            selectedRefTypeForFiles, setSelectedRefTypeForFiles,
            currentConference, setCurrentConference,
            selectedTopic, setSelectedTopic,
            departmentList, setDepartmentList,
            functionList, setFunctionList,
            deviceId, setDeviceId,
            deskData, setDeskData,
            currentParticipant, setCurrentParticipant,
            roomDataForRegister, setRoomDataForRegister,
            createNewProject, setCreateNewProject,
            currentTopic, setCurrentTopic,
            currentModeratorStream, setCurrentModeratorStream,
            currentParticipantStream, setCurrentParticipantStream,
            conferenceLogin, setConferenceLogin,
            alertMessage, setAlertMessage,
            openedFiles, setOpenedFiles,
            sharedFiles, setSharedFiles,
            openNotif, setOpenNotif,
            seeNotification, setSeeNotification,
            userDetailsComponentTimer, setUserDetailsComponentTimer,
            hasUnreadMessages, setHasUnreadMessages,
            showSettings, setShowSettings,
            showControls, setShowControls,
            seeQrCode, setSeeQrCode,
            openEditProfile, setOpenEditProfile,
            participantsStreams, setParticipantsStreams,
            refreshNotes, setRefreshNotes,
            loadingFiles, setLoadingFiles,
            extraScreenOpenConf, setExtraScreenOpenConf
        }}>
            {props.children}
        </GlobalContext.Provider>
    )
}